<template>
  <section>
    <div>
      <h4 class="body-bold-base neutral-20-dark--text">
        {{ title }}
      </h4>
      <h5 class="body-regular-smaller neutral-40-light--text">
        {{ subtitle }}
      </h5>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
  },
}
</script>
